<template>
  <div v-if="hasAuth('Report')">
    <list-container :header="editFilters ? translate('report.reportFilters') : translate('report.report')">
        <template v-slot:commands>
           <button
              class="btn btn-info"
              @click="resetComponent"
              v-show="editFilters"
            >
              {{translate('incomingDocumentList.clearFilter')}}
            </button>
          <excel-exporter
            v-show="!editFilters"
            table-id="jobReportExport"
            :columns="columns"
            url="/jobreport/get"
            modelName="Job"
          :hideDeleteCommand="true"
          :filter="filterForm"
          :predicate="predicate"
            orderBy="TrackingNo.Number desc"
          ></excel-exporter>
            <button
              accesskey="t"
              class="btn btn-primary"
              @click="editFilters = true"
              v-show="!editFilters"
              v-html="translate('incomingDocumentList.editFilters')"
            >
            </button>
        </template>

      <div class="rbcontent">
          <report-filter
            v-if="editFilters"
            :filter="filterForm"
            @apply="applyFilter"
            @cancel="editFilters = false"
            :target-systems="targetSystems"
            :circulation-profile-schemas="circulationProfileSchemas"
            :departments="availableDepartments"
            :categories="categories"
            :users="users"
          ></report-filter>

        <div class="row" v-show="!editFilters">
          <div class="col-12">
            <!-- <code>{{filterForm}}</code> -->
            <table class="table table-borderless table-sm ozet">
              <tbody>
                <tr v-show="filterForm.FirstNumber || filterForm.LastNumber">
                  <td>{{translate('reportFilter.trackingNo')}}</td>
                  <td>:</td>
                  <td>
                    {{ filterForm.FirstNumber }} — {{ filterForm.LastNumber }}
                  </td>
                </tr>
                <tr v-show="filterForm.FirstDate || filterForm.LastDate">
                  <td>{{translate('reportFilter.startDate')}}</td>
                  <td>:</td>
                  <td>
                    {{ filterForm.FirstDate | date }} —
                    {{ filterForm.LastDate | date }}
                  </td>
                </tr>
                <tr
                  v-show="
                    filterForm.FirstTargetDate || filterForm.LastTargetDate
                  "
                >
                  <td>{{translate('reportFilter.targetDate')}}</td>
                  <td>:</td>
                  <td>
                    {{ filterForm.FirstTargetDate | date }} —
                    {{ filterForm.LastTargetDate | date }}
                  </td>
                </tr>
                <tr v-show="filterForm.Title">
                  <td>{{translate('reportFilter.jobName')}}</td>
                  <td>:</td>
                  <td>{{ filterForm.Title }}</td>
                </tr>
                <tr v-show="filterForm.Status && filterForm.Status.length">
                  <td>{{translate('jobFinalizer.state')}}</td>
                  <td>:</td>
                  <td>
                    <span
                      v-for="s in filterForm.Status"
                      :key="s"
                      :class="'badge badge-' + $izonay.jobStatus[s].css"
                      style="margin-right: 8px"
                      >{{ $izonay.jobStatus[s].text }}</span
                    >
                  </td>
                </tr>
                <tr
                  v-show="
                    filterForm.DocumentTypes && filterForm.DocumentTypes.length
                  "
                >
                  <td>{{translate('report.docType')}}</td>
                  <td>:</td>
                  <td>
                    <span
                      v-for="s in filterForm.DocumentTypes"
                      :key="s"
                      class="document-type"
                      style="margin-right: 8px"
                      >{{ $izonay.documentTypes[s].text }}</span
                    >
                  </td>
                </tr>
                <tr
                  v-show="
                    filterForm.TargetSystemIds &&
                    filterForm.TargetSystemIds.length
                  "
                >
                  <td>{{translate('remPreview.receiver')}}</td>
                  <td>:</td>
                  <td>
                    <span
                      v-for="s in filterForm.TargetSystemIds"
                      :key="s"
                      class="document-type"
                      style="margin-right: 8px"
                      >{{
                        targetSystems.filter((x) => x.Id == s)[0].Name
                      }}</span
                    >
                  </td>
                </tr>
                <tr
                  v-show="
                    filterForm.CirculationProfileSchemaIds &&
                    filterForm.CirculationProfileSchemaIds.length
                  "
                >
                  <td>{{translate('reportFilter.flow')}}</td>
                  <td>:</td>
                  <td>
                    <span
                      v-for="s in filterForm.CirculationProfileSchemaIds"
                      :key="s"
                      class="document-type"
                      style="margin-right: 8px"
                      >{{
                        circulationProfileSchemas.filter((x) => x.Id == s)[0]
                          .Name
                      }}</span
                    >
                  </td>
                </tr>
                <tr v-show="filterForm.OwnerIds && filterForm.OwnerIds.length">
                  <td>{{translate('reportFilter.starter')}}</td>
                  <td>:</td>
                  <td>
                    <span
                      v-for="s in filterForm.OwnerIds"
                      :key="s"
                      class="document-type"
                      style="margin-right: 8px"
                      >{{ users.filter((x) => x.Id == s)[0].FirstName }}
                      {{ users.filter((x) => x.Id == s)[0].LastName }}</span
                    >
                  </td>
                </tr>
                <tr
                  v-show="
                    filterForm.WaitingUserIds &&
                    filterForm.WaitingUserIds.length
                  "
                >
                  <td>{{translate('reportFilter.waiter')}}</td>
                  <td>:</td>
                  <td>
                    <span
                      v-for="s in filterForm.WaitingUserIds"
                      :key="s"
                      class="document-type"
                      style="margin-right: 8px"
                      >{{ users.filter((x) => x.Id == s)[0].FirstName }}
                      {{ users.filter((x) => x.Id == s)[0].LastName }}</span
                    >
                  </td>
                </tr>
                <tr
                  v-show="
                    filterForm.ApprovedUserIds &&
                    filterForm.ApprovedUserIds.length
                  "
                >
                  <td>{{translate('reportFilter.signerOrApprover')}}</td>
                  <td>:</td>
                  <td>
                    <span
                      v-for="s in filterForm.ApprovedUserIds"
                      :key="s"
                      class="document-type"
                      style="margin-right: 8px"
                      >{{ users.filter((x) => x.Id == s)[0].FirstName }}
                      {{ users.filter((x) => x.Id == s)[0].LastName }}</span
                    >
                  </td>
                </tr>
                <tr
                  v-show="
                    filterForm.REMSenderUserIds &&
                    filterForm.REMSenderUserIds.length
                  "
                >
                  <td>{{translate('reportFilter.senderWithRem')}}</td>
                  <td>:</td>
                  <td>
                    <span
                      v-for="s in filterForm.REMSenderUserIds"
                      :key="s"
                      class="document-type"
                      style="margin-right: 8px"
                      >{{ users.filter((x) => x.Id == s)[0].FirstName }}
                      {{ users.filter((x) => x.Id == s)[0].LastName }}</span
                    >
                  </td>
                </tr>
                <tr v-show="filterForm.OnlyRevisions">
                  <td colspan="3">{{translate('report.onlyRevisions')}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <list
        v-if="!editFilters"
        ref="jobList"
        class="table-sm"
        :record-per-page="20"
        :columns="columns"
        url="/jobreport/get"
        modelName="Job"
        :hideDeleteCommand="true"
        :filter="filterForm"
        orderBy="TrackingNo.Number desc"
        :predicate="predicate"
      >
      </list>
    </list-container>
    <router-view v-if="$route.params.id" />
  </div>
  <div v-else class="alert alert-danger">
    {{translate('errors.notAuthorizedForTheProcess')}}
  </div>
</template>

<script>
import Vue from "vue";
import list from "../components/List.vue";
import listContainer from "../components/ListContainer.vue";
import reportFilter from "../components/ReportFilter.vue";
import ExcelExporter from "../components/ExcelExporter.vue";
import i18n from "../i18n";
export default {
    components: {
        list,ExcelExporter,
        listContainer,
        reportFilter
    },
    data(){
        return {
            user: null,
            filterForm: { Status:[], DocumentTypes: [] },
            targetSystems: [],
            circulationProfileSchemas: [],
            departments: [],
            categories: [],
            users: [],
            predicate: "",
            editFilters: false,
            columns : [
                {
                    Key: "TrackingNo",
                    Title: this.translate('reportFilter.trackingNo'),
                    SortField: "TrackingNo.Number",
                    Content(i) {
                        return Vue.filter('trackingNo')(i.TrackingNo);
                    }
                },
                {
                    Key: "Title",
                    Title: this.translate('reportFilter.jobName'),
                    SortField: "Title"
                },
                // {
                //     Key: "DocumentNumber",
                //     Title: "Belge No",
                //     SortField: "DocumentNumber"
                // },
                {
                    Key: "Owner",
                    Title:this.translate('reportFilter.starter'),
                    //SortField: "Owner.Fl, Owner.LastName",
                    Content(i) {
                        return `${Vue.filter('stripHTML')(i.Owner.FirstName)} ${Vue.filter('stripHTML')(i.Owner.LastName)}`
                    }
                },
                {
                    Key: "Waiting",
                    Title:this.translate('jobList.waiting'),
                    Content(i) {
                        var currentStep = i.CurrentStep;
                        var result = '';

            if (currentStep) {
              for (var c = 0; c < currentStep.WaitingUsers.length; c++) {
                result += Vue.filter('stripHTML')(currentStep.WaitingUsers[c].FullName);
                if (c < currentStep.WaitingUsers.length - 2) {
                  result += ", ";
                } else if (c < currentStep.WaitingUsers.length - 1) {
                  result +=
                    currentStep.Condition == "All"
                      ? i18n.t('jobList.and')
                      : i18n.t('jobList.or');
                }
              }
            }

            return result;
          },
        },
        {
          Key: "StartDate",
          Title: this.translate('draftEyp.date'),
          SortField: "StartDate",
          Content(i) {
            return Vue.filter("datetime")(i.StartDate);
          },
        },
        // {
        //   Key: "CirculationProfileSchemaName",
        //   Title: "İş Akışı",
        // },
        {
          Key: "State",
          Title: this.translate('jobFinalizer.state'),
          SortField: "State",
          Content(i) {
            return Vue.filter("jobStatus")(i.State);
          },
        },
        {
          Key: "Recipient",
          Title: this.translate('circulationProfileSchema.targetSystems'),
        },
      ],
    };
  },
  created() {
    this.getTargetSystems().then((x) => {
      this.targetSystems = x.Result;
    });

    this.getDepartments({ Predicate: "IsActive=true" }).then(
      (x) => {
        this.departments = x.Result;

        this.getUsers({ predicate: "IsActive= true", DepartmentIds: this.userDepartmentIds, IncludeFreeUsersInDepartmentFilter: true }).then((x) => {
          this.users = x.Result;
        });
      }
    );

    this.getCategories({ Predicate: "IsActive=true" }).then(x => {
      this.categories = x.Result;
    });

    this.getCirculationProfileSchemas({ Predicate: "IsActive=true" }).then(
      (x) => {
        this.circulationProfileSchemas = x.Result;
      }
    );
  },
  methods: {
    applyFilter(filter) {
      this.filterForm = filter;
      this.editFilters = false;
      this.$forceUpdate();
    },
    resetComponent() {
      if (
        confirm(this.translate('warnings.reportFilterWillBeGone'))
      ) {
        this.applyFilter({ Status:[], DocumentTypes: [] })
      }
    },
  },
  computed:{
    userDepartmentIds(){
      var userDepartmentIds = this.$root?.$data?.login?.User?.DepartmentIds ?? [];
      var allDepartmentIds = (this.departments ?? []).filter(x => x.IsActive).map(function(item) { return item.Id});

      if(this.hasAuth('Admin'))
        return [];
      else
        return userDepartmentIds.filter(x => allDepartmentIds.indexOf(x) >= 0);
    },
    availableDepartments(){
        var result = (this.departments ?? []).filter(x => x.IsActive);
        var userDepartmentIds = this.userDepartmentIds;

        if(!this.hasAuth('Admin') && (userDepartmentIds ?? []).length > 0) {
          var isDepartmentAvailable = function(department) {
            return userDepartmentIds.indexOf(department.Id) >= 0;
          }
          result = result.filter(x => isDepartmentAvailable(x));
        }
          
        
        return result;
    }
  }
};
</script>
<style scoped>
table.ozet > tbody > tr > td:first-child {
  width: 150px;
}

.document-type::after {
  content: ",";
}

.document-type:last-child::after {
  content: "";
}
</style>